import Button from "../Button";
import {MdErrorOutline, MdOutlineCheckCircle} from "react-icons/md";
import {useContext} from "react";
import FinCheckContext from "../../tools/contexts/finCheck/FincheckContext";

const Result = ({title, message, isError}) => {
    const finCheckContext = useContext(FinCheckContext);
    const handleRedirect = () => {
        const status = isError ? 'fail' : 'success';
        const price =finCheckContext?.process?.payment?.info?.init_amount ? finCheckContext?.process?.payment?.info?.init_amount  : 0
        finCheckContext.handleRedirect(status,price)
    }
    return <div className="bg-white lg:w-8/12 mx-auto flex flex-col items-center justify-center shadow-sm p-5 rounded-lg ">
        {isError ? <MdErrorOutline className="text-6xl text-red-500"/> :
            <MdOutlineCheckCircle className="text-6xl text-green-500"/>}
        <strong className={`${isError ? 'text-red-500' : 'text-green-500'} text-center mt-2`}>{title}</strong>
        <p className="text-sm text-center">{message}</p>
        <Button onClick={handleRedirect} rounded="rounded-lg" theme="green"
                className="text-sm mt-5 pt-5 border-t w-full ">بازگشت به دیوار</Button>
    </div>;
}
export default Result;